import type { RouteSectionProps } from "@solidjs/router";
import Nav from "../components/Nav";

export default function MapLayout(props: RouteSectionProps) {
  return (
    <div class="flex flex-col h-dvh">
      <Nav />
      <div class="flex-1 min-h-0">{props.children}</div>
    </div>
  );
}
